import { api as generatedApi } from "~/gql/generatedApi.generated";
import {
	GetWsapiImportsDocument,
	GetWsapiImportsQuery,
	GetWsapiImportsQueryVariables
} from "~/gql/queries/wsapiImport.generated";

const wsapiImportApi = generatedApi.injectEndpoints({
	endpoints: (build) => ({
		GetWsapiImports: build.query<GetWsapiImportsQuery, GetWsapiImportsQueryVariables | void>({
			forceRefetch({ currentArg, previousArg }) {
				return (
					JSON.stringify(currentArg?.where) !== JSON.stringify(previousArg?.where) ||
					currentArg?.first !== previousArg?.first
				);
			},
			merge(currentCache, newData) {
				if (currentCache.wsapiImports && newData.wsapiImports) {
					const existingMap = new Map((currentCache.wsapiImports.nodes || []).map((n) => [n.wsapiImportId, n]));
					for (const node of newData.wsapiImports.nodes || []) {
						existingMap.set(node.wsapiImportId, node);
					}
					currentCache.wsapiImports.nodes = [...existingMap.values()];
					currentCache.wsapiImports.totalCount = newData.wsapiImports.totalCount;
				}
			},
			query: (variables) => ({ document: GetWsapiImportsDocument, variables }),
			serializeQueryArgs: ({ endpointName, queryArgs }) => {
				return `${endpointName}-${JSON.stringify(queryArgs?.where ?? {})}`;
			}
		})
	}),
	// overrideExisting is required so the paginated config (merge, serializeQueryArgs, forceRefetch) takes effect over the codegen stub
	overrideExisting: true
});

export default wsapiImportApi;
